import { render, staticRenderFns } from "./PopoverShare.vue?vue&type=template&id=5aca7adc"
import script from "./PopoverShare.vue?vue&type=script&lang=js"
export * from "./PopoverShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports